import { useMemo } from 'react';

import { Text } from '@/components/shared/element/text';
import { Box } from '@/components/shared/layout/box';
import { Container } from '@/components/shared/layout/container';

interface MaintenanceListTableBriefSpecialInfoProps {
  maintenanceDescription: string;
  specialCostDescription?: string;
}

export const MaintenanceListTableBriefSpecialInfo = (
  props: MaintenanceListTableBriefSpecialInfoProps
) => {
  const specialCostDescriptionHtmlFormatted = useMemo(() => {
    if (!props.specialCostDescription) return '';
    const splitTexts = props.specialCostDescription.split('เพียง ');
    const boldText = ` เพียง <strong>${splitTexts[1]}</strong>`;
    return `**${splitTexts[0]}${boldText}**`;
  }, [props.specialCostDescription]);

  if (!!props.maintenanceDescription && !!props.specialCostDescription) {
    return <></>;
  }

  return (
    <Box
      textAlign="center"
      paddingY="3"
      css={{
        bc: '$primary-300',
        marginTop: !props.specialCostDescription ? '$space-4' : undefined,
      }}
    >
      <Container size="sm">
        {props.maintenanceDescription ? (
          <Text size="text-base-2" variant="text-red">
            {props.maintenanceDescription}
          </Text>
        ) : (
          <Text
            dangerouslySetInnerHTML={{
              __html: specialCostDescriptionHtmlFormatted,
            }}
          />
        )}
      </Container>
    </Box>
  );
};

MaintenanceListTableBriefSpecialInfo.displayName =
  'SectionMaintenanceListTableBriefSpecialInfo';
